/**
 * Do not rename this file or move the events elsewhere, as this file will be
 * referenced by permalink as the source of truth for Mixpanel events and pages
 */

/** Keep all page names here, using string for the value. E.g.: MyPage = 'My Page' */
export enum MixpanelPage {
  ShowingConfiguration = 'Showing Configuration',
  AnalyticsShowingInsights = 'Analytics - Showing Insights',
  AnalyticsMarketTrends = 'Analytics - Market Trends',
  AnalyticsMyBrokerage = 'Analytics - My Brokerage',
  BookShowingExternalDashboard = 'Book Showing - External Dashboard',
}

/** Keep all event names here, using string for the value. E.g.: MyEvent = 'My Event' */
export enum MixpanelEvent {
  DailySession = 'Daily Session',
  ShowingConfigurationSaved = 'Showing Configuration Saved',
}
